module.exports = __webpack_public_path__ + "static/media/PORTADA_CICLO_4_EMPRENDIMIENTO.fa6634e3.jpg";